const LOG_GATES = {
  deployButton: false,
};

type LogGate = keyof typeof LOG_GATES;

(window as any).setLogGate = (gate: LogGate, value: boolean) => {
  LOG_GATES[gate] = value;
};

export function gatedLogger(gates: LogGate | LogGate[], ...msgs: any[]) {
  if ([gates].flat().some((gate) => LOG_GATES[gate])) {
    console.log(...msgs);
  }
}
